export default __webpack_public_path__ + "static/media/pantry2-before1-480w.63d7ded6.png";